import React,{useState, useEffect} from 'react'
import { Modal } from 'react-bootstrap';
import './uploadeditfilesandimages.css'
import { AiOutlineCheckCircle } from 'react-icons/ai'
import { exportToExcel } from '../../../service/utilService';



export default function SubmittedPopup({ response, showSuccessPopup, setShowSuccessPopup }) {
    const [unmatchrecord, setUnmatchRecord] = useState([]);

  useEffect(() => {
      if (response)
      setUnmatchRecord(response.unMatchedRecords || [])
  }, [response.unMatchedRecords])

  const exportExcel=()=>{
      exportToExcel(unmatchrecord,"Json","Unmatch_Records");
  }

    return (
        <div>
            <Modal show={showSuccessPopup} size="md" centered onHide={() => setShowSuccessPopup(false)}>
                <Modal.Body>
                    <div style={{ textAlign: 'center',flex:1 }}>
                        <AiOutlineCheckCircle className="checkIcon" />
                        <br />
                        <span style={{ color: '#1BB5AD', fontSize: 42,  fontFamily: 'Inter, sans-serif',fontWeight: 'bold', lineHeight: '55px', letterSpacing: '2.1px'}}>Submited</span>
                        <br />
                        <br />
                        <span style={{ color: '#303A78', fontSize: 15, fontWeight: 500 }}> {+response.totalXLSRecords - +unmatchrecord.length} violations submitted out of {(response.totalXLSRecords && response.totalXLSRecords[0]) || 0} violations
                            <br />
                            <br />
                            {response.totalUnmatchedImages} violations image name not matching with files </span>
                        <br />
                        <span style={{ color: '#137BFD', fontSize: 18, margin: 8, display: 'inline-block', cursor:'pointer' }} onClick={exportExcel}>Download unmatched violations</span>
                        <br />
                        <br />
                        <br />
                        <div className="upload-popup-btns">
                            <button style={{ backgroundColor: '#303A78' }} onClick={() => setShowSuccessPopup(false)} >Ok</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}
